import { render, staticRenderFns } from "./MailContent.vue?vue&type=template&id=eaa95564&"
import script from "./MailContent.vue?vue&type=script&lang=js&"
export * from "./MailContent.vue?vue&type=script&lang=js&"
import style0 from "./MailContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports